








import React, { useEffect, useState } from "react";
import "../assets/employereportnew.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport, deleteEmployee } from "../redux/slices/employeeReportSlice";
import { toast } from "react-toastify";
import EmployeeEditModal from "../modals/EmployeeEditModal";
import axios from "axios";
import { fetchRoles } from "../redux/slices/roleSlice";
import { getBranches } from "../redux/slices/branchSlice";
import { Eye, Trash } from "lucide-react";



import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const EmployeeReport = () => {
  const dispatch = useDispatch();
  const { list: data, loading, error, currentPage, totalPages } = useSelector(
    (state) => state.employeeReport
  );
    const { items: roles } = useSelector((state) => state.roles);
    const { branches } = useSelector((state) => state.branch);


    const [employeeDetails, setEmployeeDetails] = useState(null);
const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  // console.log("employee data",data)
  const [filterType, setFilterType] = useState("userId");
  const [filterValue, setFilterValue] = useState("");
  const [branch, setBranch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
    const [modalConfig, setModalConfig] = useState({
      isOpen: false,
      loanId: null,
      type: "",
    });

  const pageSize = 10;

  const fetchData = (page = 1) => {
    dispatch(
      fetchEmployeeReport({
        page,
        pageSize,
        filterType,
        filterValue,
        branch,
        fromDate,
        toDate,
      })
    );
  };




  const openEmployeeDetails = (employee) => {
  setEmployeeDetails(employee);
  setDetailsModalOpen(true);
};

const closeEmployeeDetails = () => {
  setDetailsModalOpen(false);
  setEmployeeDetails(null);
};

  useEffect(() => {
    fetchData(1);
  }, []);


    useEffect(() => {
      dispatch(fetchRoles());
      // dispatch(getBranches());
      dispatch(getBranches({ fetchAll: true }));
  
    }, [dispatch]);



const downloadExcel = () => {
  if (!data || data.length === 0) {
    toast.error("No data found");
    return;
  }

  const excelData = data.map((row, index) => ({
    SN: (currentPage - 1) * pageSize + index + 1,
    EmployeeID: row.userId || "N/A",
    Name: row.fullName || "N/A",
    Email: row.email || "N/A",
    Phone: row.mobileNumber || "N/A",
    Branch: row.branchName || "N/A",
    Role: row.roleName || "N/A",
    Aadhaar: row.aadhaarNumber || "N/A",
    PAN: row.panNumber || "N/A",
    Address: row.address || "N/A",
    DOB: row.dateOfBirth
      ? new Date(row.dateOfBirth).toLocaleDateString("en-GB")
      : "N/A",
    JoiningDate: row.dateOfJoining
      ? new Date(row.dateOfJoining).toLocaleDateString("en-GB")
      : "N/A",
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const fileData = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(fileData, `Employee_Report_${Date.now()}.xlsx`);
};





const downloadCSV = () => {
  if (!data || data.length === 0) {
    toast.error("No data found");
    return;
  }

  const csvData = data.map((row, index) => ({
    SN: (currentPage - 1) * pageSize + index + 1,
    EmployeeID: row.userId || "N/A",
    Name: row.fullName || "N/A",
    Email: row.email || "N/A",
    Phone: row.mobileNumber || "N/A",
    Branch: row.branchName || "N/A",
    Role: row.roleName || "N/A",
    Aadhaar: row.aadhaarNumber || "N/A",
    PAN: row.panNumber || "N/A",
  }));

  const worksheet = XLSX.utils.json_to_sheet(csvData);

  const csvOutput = XLSX.utils.sheet_to_csv(worksheet);

  const blob = new Blob([csvOutput], {
    type: "text/csv;charset=utf-8;",
  });

  saveAs(blob, `Employee_Report_${Date.now()}.csv`);
};




const downloadPDF = () => {
  if (!data || data.length === 0) {
    toast.error("No data found");
    return;
  }

  const doc = new jsPDF("landscape");

  doc.setFontSize(16);
  doc.text("Employee Report", 14, 15);

  const tableColumn = [
    "SN",
    "Emp ID",
    "Name",
    "Email",
    "Phone",
    "Branch",
    "Role",
    "Aadhaar",
    "PAN",
  ];

  const tableRows = [];

  data.forEach((row, index) => {
    tableRows.push([
      (currentPage - 1) * pageSize + index + 1,
      row.userId || "N/A",
      row.fullName || "N/A",
      row.email || "N/A",
      row.mobileNumber || "N/A",
      row.branchName || "N/A",
      row.roleName || "N/A",
      row.aadhaarNumber || "N/A",
      row.panNumber || "N/A",
    ]);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 25,
    styles: {
      fontSize: 8,
    },
  });

  doc.save(`Employee_Report_${Date.now()}.pdf`);
};



const handlepreviewclick = async (id) =>{
  const superAdminId=localStorage.getItem("adminuserId")
  const imageStatus="Approved";
     try {
        const res = await fetch(
          `https://narrowitsolution.in/api/list-employee-kyc?userId=${id}&superAdminId=${superAdminId}&status=${imageStatus}`
        );
        const data = await res.json();
        if (res.ok && data.documents?.length > 0) {
          const photoDoc = data.documents.find(
            (doc) => doc.docName?.toLowerCase() === "photo" && doc.status?.toLowerCase()==="approved"
          );

        

          // console.log("photoDoc.docImage");
          console.log(photoDoc.docImage);
          if (photoDoc?.docImage) {
            // setPhotoUrl(`https://narrowitsolution.in/uploads/${photoDoc.docImage}`);
            setPreviewImage(`https://narrowitsolution.in/uploads/${photoDoc.docImage}`)
          }
        }
       else {
        toast.error("Employee image not Found.")
       }
      } catch (err) {
        console.error("Failed to fetch employee photo:", err);
      }
      
    };

      // Open the modal
  const openModal = (id, type) => {
    setModalConfig({ isOpen: true, loanId: id, type });
  };

  // Close the modal
  const closeModal = () => {
    setModalConfig({ isOpen: false, loanId: null,});
  };


  const handleDelete = async () => {
    const {loanId}=modalConfig
    // if (!window.confirm("Are you sure you want to delete this employee?")) return;
    try {
      await dispatch(deleteEmployee(loanId)).unwrap();
      toast.success("Employee deleted successfully!");
      fetchData(currentPage); // refresh current page
    } catch (err) {
      toast.error(err);
    }finally{
      closeModal();
    }
  };

  // console.log("data is ",data);


  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      fetchData(pageNumber);
    }
  };

  return (
    <div className="CustomerReport-container">
      <h2 className="CustomerReport-heading">Employee Report</h2>

      {/* Filters */}
      <div className="CustomerReport-filterSection">
        <div className="CustomerReport-filterGroup">
          <label>From Date</label>
          <input
            type="date"
            className="CustomerReport-input"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="CustomerReport-filterGroup">
          <label>To Date</label>
          <input
            type="date"
            className="CustomerReport-input"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        {/* <div className="CustomerReport-filterGroup">
          <label>Branch</label>
          <input
            type="text"
            className="CustomerReport-input"
            placeholder="Enter Branch"
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
          />
        </div> */}
        <div className="CustomerReport-filterGroup">
          <label>Filter By</label>
          <select
            className="CustomerReport-input"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="userId">User ID</option>
            {/* <option value="aadhar">Aadhar</option>
            <option value="pan">PAN</option>
            <option value="phone">Mobile</option>
            <option value="dob">DOB</option>
            <option value="name">Name</option> */}
          </select>
        </div>
        <div className="CustomerReport-filterGroup">
          <label>{filterType.toUpperCase()}</label>
          <input
            type={filterType === "dob" ? "date" : "text"}
            className="CustomerReport-input"
            placeholder={`Enter ${filterType.toUpperCase()}`}
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
          />
        </div>
        <div className="CustomerReport-filterGroup buttonWrapper">
          <button className="CustomerReport-submit" onClick={() => fetchData(1)}>
            Submit
          </button>
        </div>
      </div>


      <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "15px",
  }}
>
  <button
    className="CustomerReport-submit"
    onClick={downloadExcel}
  >
    Export Excel
  </button>

  <button
    className="CustomerReport-submit"
    onClick={downloadCSV}
  >
    Export CSV
  </button>

  <button
    className="CustomerReport-submit"
    onClick={downloadPDF}
  >
    Export PDF
  </button>
</div>

      {/* Table */}
      <div className="CustomerReport-tableWrapper">
        {loading ? (
          <p style={{ textAlign: "center" }}>Loading...</p>
        ) : error ? (
          <p style={{ color: "red", textAlign: "center" }}>{error}</p>
        ) : (
          <>
            <table className="CustomerReport-table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Image</th>
                  <th>Emp. ID</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Branch</th>
                  <th>Role</th>
                  <th>Aadhar</th>
                  <th>PAN</th>
                  <th>Address</th>
                  <th>DOB</th>
                  <th>Joining Date</th>
                  <th>Details</th>
                  
                  <th>Update</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((row, index) => (
                    <tr key={row.id}>
                      <td>{(currentPage - 1) * pageSize + index + 1}</td>
                      {/* <td>
                        <img
                          src={`https://ui-avatars.com/api/?name=${row.id}&background=random`}
                          alt="Profile"
                        />
                      </td> */}
                      <td>
                        <button
                          className="preview-btn-emprpt"
                          onClick={() =>
                            handlepreviewclick(row.userId)
                          }
                        >
                          <Eye/>
                        </button>
                      </td>
                     
                      <td>{row.userId||"N/A"}</td>
                      <td>{row.fullName||"N/A"}</td>
                      <td>{row.email||"N/A"}</td>
                      <td>{row.mobileNumber||"N/A"}</td>
                      <td>{row.branchName||"N/A"}</td>
                      <td>{row.roleName||"N/A"}</td>
                      <td>{row.aadhaarNumber||"N/A"}</td>
                      <td>{row.panNumber||"N/A"}</td>
                      <td>{row.address||"N/A"}</td>
                      <td>{new Date(row.dateOfBirth).toLocaleDateString("en-GB")||"N/A"}</td>
                      <td>{new Date(row.dateOfJoining).toLocaleDateString("en-GB")||"N/A"}</td>
                      <td>
  <button
    className="CustomerReport-action"
    onClick={() => openEmployeeDetails(row)}
  >
    View
  </button>
</td>
                      <td>
                        <button
                          className="CustomerReport-action"
                          onClick={() => {
                            setIsModalOpen(true);
                            setSelectedEmployee(row);
                          }}
                          title="Update"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </td>

                      <td>
                        <button
                          className="CustomerReport-action delete-btn"
                          onClick={() => openModal(row.id, "delete")}
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" style={{ textAlign: "center" }}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

         
          </>
        )}
      </div>

      {/* Pagination */}
         {totalPages > 1 && (
              <div className="CustomerReport-paginationCard">
                <div className="CustomerReport-pagination">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  <span className="CustomerReport-pageIndicator">
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}


            {/* 🔹 Preview Modal */}
            {previewImage && (
              <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <img src={previewImage} alt="KYC Preview" className="modal-image" />
                  <button
                    className="modal-close"
                    onClick={() => setPreviewImage(null)}
                  >
                    ×
                  </button>
                </div>
              </div>
            )}

            {/* --- ACTION MODAL --- */}
                  {modalConfig.isOpen && (
                    <div className="loan-pre-closer-modal-overlay">
                      <div className="loan-pre-closer-modal-content">
                        <div className={`loan-pre-closer-modal-icon icon-delete`}>
                          <Trash size={40} />
                        </div>
                        <h2>
                          Confirm{" "}
                          {"delete".charAt(0).toUpperCase() +
                            "delete".slice(1)}
                        </h2>
                        <p>
                          Are you sure you want to <b>delete</b> this loan
                          record? This action might be irreversible.
                        </p>
            
                        <div className="loan-pre-closer-modal-actions">
                          <button className="loan-pre-closer-btn-cancel" onClick={closeModal}>
                            Cancel
                          </button>
                          <button
                            className={`loan-pre-closer-btn-confirm btn-delete`}
                            onClick={handleDelete}
                          >
                            Confirm Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  )}


                  {detailsModalOpen && employeeDetails && (
  <div className="employee-details-overlay">
    <div className="employee-details-modal">

      <div className="employee-details-header">
        <h2>Employee Details</h2>

        <button
          className="employee-details-close"
          onClick={closeEmployeeDetails}
        >
          ×
        </button>
      </div>

      <div className="employee-details-body">

        <div className="employee-grid">
          <div><strong>Employee ID:</strong> {employeeDetails.userId}</div>
          <div><strong>Full Name:</strong> {employeeDetails.fullName}</div>
          <div><strong>Guardian:</strong> {employeeDetails.guardianName}</div>
          <div><strong>Gender:</strong> {employeeDetails.gender}</div>
          <div><strong>Mobile:</strong> {employeeDetails.mobileNumber}</div>
          <div><strong>Email:</strong> {employeeDetails.email}</div>
          <div><strong>Branch:</strong> {employeeDetails.branchName}</div>
          <div><strong>Role:</strong> {employeeDetails.roleName}</div>
          <div><strong>Aadhaar:</strong> {employeeDetails.aadhaarNumber}</div>
          <div><strong>PAN:</strong> {employeeDetails.panNumber}</div>
          <div><strong>Bank:</strong> {employeeDetails.bankName}</div>
          <div><strong>IFSC:</strong> {employeeDetails.bankIFSC}</div>
          <div><strong>Account:</strong> {employeeDetails.bankAccount}</div>
          <div><strong>District:</strong> {employeeDetails.district}</div>
          <div><strong>State:</strong> {employeeDetails.state}</div>
          <div><strong>Pincode:</strong> {employeeDetails.pincode}</div>
          <div><strong>Address:</strong> {employeeDetails.address}</div>
          <div><strong>Marital Status:</strong> {employeeDetails.maritalStatus}</div>

          <div>
            <strong>DOB:</strong>{" "}
            {new Date(employeeDetails.dateOfBirth).toLocaleDateString("en-GB")}
          </div>

          <div>
            <strong>Joining Date:</strong>{" "}
            {new Date(employeeDetails.dateOfJoining).toLocaleDateString("en-GB")}
          </div>
        </div>

      </div>
    </div>
  </div>
)}

            {/* Edit Modal */}
            <EmployeeEditModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              employee={selectedEmployee}
              onUpdated={() => fetchData(currentPage)}
              branches={branches}
              roles={roles}
            />
    </div>
  );
};

export default EmployeeReport;